import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";

/**
 * @name StatesCustomSelect
 * @function
 * @param {STRING|NULL} value - the name of a state for a selected state
 * @param {Function|NULL} onChange - A function that gets called and passed a value when the select value changes.
 * @param {STRING|NULL} dataPoint - A string that places a data point on the select and each select option.
 * @extends React.Component
 * @exported true
 * @description A custom select component that shows the states of the United States.
 * @example 
 *  <StatesCustomSelect value={ payee.financialInstitutionState } onChange={ onChange("financialInstitutionState") }/>
 */
export default function StatesCustomSelect(props) {
    const dataPointSelect = props.dataPoint ? { dataPoint: `${ props.dataPoint }_State_Select` } : {};
    
    const items = states.reduce((acc, state) => {
        const dataPointSelectState = props.dataPoint ? { dataPoint: `${ props.dataPoint }_Option_State_${ state.value }` } : {};
        
        acc.push(
            <CustomSelectItem key={ state.value } { ...dataPointSelectState } value={ state.value }>{ state.label }</CustomSelectItem>
        );
        return acc;
    }, []);

    return (
        <CustomSelect active={ props.active } value={ props.value } { ...dataPointSelect } onChange={ props.onChange }>
            { items }
        </CustomSelect>
    );
}

const states = [
  { value: "alabama", label: "ALABAMA" },
  { value: "alaska", label: "ALASKA" },
  { value: "arizona", label: "ARIZONA" },
  { value: "arkansas", label: "ARKANSAS" },
  { value: "california", label: "CALIFORNIA" },
  { value: "colorado", label: "COLORADO" },
  { value: "connecticut", label: "CONNECTICUT" },
  { value: "delaware", label: "DELAWARE" },
  { value: "florida", label: "FLORIDA" },
  { value: "georgia", label: "GEORGIA" },
  { value: "hawaii", label: "HAWAII" },
  { value: "idaho", label: "IDAHO" },
  { value: "illinois", label: "ILLINOIS" },
  { value: "indiana", label: "INDIANA" },
  { value: "iowa", label: "IOWA" },
  { value: "kansas", label: "KANSAS" },
  { value: "kentucky", label: "KENTUCKY" },
  { value: "louisiana", label: "LOUISIANA" },
  { value: "maine", label: "MAINE" },
  { value: "maryland", label: "MARYLAND" },
  { value: "massachusetts", label: "MASSACHUSETTS" },
  { value: "michigan", label: "MICHIGAN" },
  { value: "minnesota", label: "MINNESOTA" },
  { value: "mississippi", label: "MISSISSIPPI" },
  { value: "missouri", label: "MISSOURI" },
  { value: "montana", label: "MONTANA" },
  { value: "nebraska", label: "NEBRASKA" },
  { value: "nevada", label: "NEVADA" },
  { value: "new hampshire", label: "NEW HAMPSHIRE" },
  { value: "new jersey", label: "NEW JERSEY" },
  { value: "new mexico", label: "NEW MEXICO" },
  { value: "new york", label: "NEW YORK" },
  { value: "north carolina", label: "NORTH CAROLINA" },
  { value: "north dakota", label: "NORTH DAKOTA" },
  { value: "ohio", label: "OHIO" },
  { value: "oklahoma", label: "OKLAHOMA" },
  { value: "oregon", label: "OREGON" },
  { value: "pennsylvania", label: "PENNSYLVANIA" },
  { value: "rhode island", label: "RHODE ISLAND" },
  { value: "south carolina", label: "SOUTH CAROLINA" },
  { value: "south dakota", label: "SOUTH DAKOTA" },
  { value: "tennessee", label: "TENNESSEE" },
  { value: "texas", label: "TEXAS" },
  { value: "utah", label: "UTAH" },
  { value: "vermont", label: "VERMONT" },
  { value: "virginia", label: "VIRGINIA" },
  { value: "washington", label: "WASHINGTON" },
  { value: "west virginia", label: "WEST VIRGINIA" },
  { value: "wisconsin", label: "WISCONSIN" },
  { value: "wyoming", label: "WYOMING" }
];